<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>订单支付</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="form-box pay__pro">
            <div class="pay--header">
                <div class="title">
                    <div class="status-bar">
                        还差最后一步，付款成功后服务成果即可确认成功！
                    </div>
                    <div class="price">
                        <span class="label">实付金额:</span>
                        <span class="value">{{parseAmount(info.to_pay)}}</span>
                    </div>
                </div>
                <div class="desc">
                    <div class="tips">
                        放弃支付或支付不成功，需要重新确认服务成果
                    </div>
                    <div class="pop-handle">
                        <el-popover
                            placement="bottom-end"
                            width="1000"
                            trigger="click">
                            <div class="content">
                                <div class="caption">
                                    <div class="cell">服务内容</div>
                                    <div class="cell">单位</div>
                                    <div class="cell">服务要求</div>
                                    <div class="cell">确认数量</div>
                                    <div class="cell">奖励金额</div>
                                    <div class="cell">确认单价</div>
                                </div>
                                <div class="box" v-for="(item, index) in info.service" :key="index">
                                    <div class="cell">
                                        <el-tooltip :content="item.name">
                                            <div class="content-ellipsis">{{item.name}}</div>
                                        </el-tooltip>
                                    </div>
                                    <div class="cell">{{item.unit}}</div>
                                    <div class="cell">
                                        <el-tooltip :content="item.demand">
                                            <div class="content-ellipsis">{{item.demand}}</div>
                                        </el-tooltip>
                                    </div>
                                    <div class="cell">{{item.amount}}</div>
                                    <div class="cell">
                                        {{item.award}}
                                    </div>
                                    <div class="cell">{{item.price}}</div>
                                </div>
                                <div class="box no-top-border">
                                    <div class="cell">服务总计</div>
                                    <div class="cell"></div>
                                    <div class="cell"></div>
                                    <div class="cell"></div>
                                    <div class="cell"></div>
                                    <div class="cell">{{info.to_pay_money}}</div>
                                </div>
                                <div class="box">
                                    <div class="cell">平台综合服务费</div>
                                    <div class="cell"></div>
                                    <div class="cell"></div>
                                    <div class="cell"></div>
                                    <div class="cell"></div>
                                    <div class="cell">{{info.to_pay_fee}}</div>
                                </div>
                                <div class="box">
                                    <div class="cell">待支付总额</div>
                                    <div class="cell"></div>
                                    <div class="cell"></div>
                                    <div class="cell"></div>
                                    <div class="cell"></div>
                                    <div class="cell">{{info.to_pay}}</div>
                                </div>

                            </div>
                            <el-button slot="reference" type="text">成果详情 <i class="el-icon-caret-bottom"></i>
                            </el-button>
                        </el-popover>
                    </div>
                </div>
            </div>
            <div class="pay--content">
                <el-form ref="form" class="pay-form" :model="form" @submit.native.prevent style="width: 360px;margin: 0 auto;"
                         label-width="80px">
                    <el-form-item label="支付方式">
                        余额支付
                    </el-form-item>
                    <el-form-item label="支付金额">
                        {{info.to_pay}}
                    </el-form-item>
                    <el-form-item label="支付密码">
                        <el-input v-model="form.pay_password" placeholder="请输入支付密码" type="password"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="paySubmit">支付</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'ServicePay',
    data () {
        return {
            userInfo: {},
            info: {
                service: []
            },
            form: {
                pay_password: ''
            }
        }
    },
    mounted () {
        this.getUserInfo()
        this.getInfo(this.$route.query.id, this.$route.query.sub_id, this.$route.query.pre_id)
    },
    methods: {
        getInfo (id, sub_id, pre_id) {
            this.$http.get('/api/user/project/subpayinfo', {
                params: {
                    id,
                    sub_id,
                    pre_id
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.info = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        paySubmit () {
            if (this.form.pay_password === '') {
                this.$message.error('请输入支付密码')
            } else if (!this.info.id) {
                this.$message.error('系统错误，请重新提交订单')
                router.replace('/index/project')
            } else {
                // TODO： 支付
                this.$http.post('/api/user/project/subpay', qs.stringify({
                    id: this.info.id,
                    sub_id: this.info.sub_id,
                    pre_id: this.info.pre_id,
                    pay_password: this.form.pay_password
                }))
                    .then((res) => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: '支付成功。'
                            })
                            if (this.userInfo.role_id === 3) {
                                router.replace(`/index/pay/record`)
                            } else {
                                router.replace(`/index/project/serviceinfo?id=${this.info.id}&sub_id=${this.info.sub_id}`)
                            }
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        // this.$Message.error('网络错误，请稍候再试。');
                    })
            }
        },
        parseAmount (num) {
            return (num * 1).toLocaleString('zh', { style: 'currency', currency: 'CNY' })
        },
        getUserInfo () {
            this.$http.get('/api/user/userinfo')
                .then(res => {
                    if (res.code === 0) {
                        this.userInfo = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    @import "../../assets/style/sub.scss";

    .table {
        margin: 24px 20px 0;
        border: 1px solid $--border-color-light;
        border-bottom-width: 0;
    }

    .alert-area {
        margin-top: 5px;
        margin-bottom: -10px;
    }

    .pro-info-box {
        margin-top: 20px;
    }

    .content {
        padding: 0 20px;

        .caption {
            display: flex;
            background-color: #F5F5FA;
            color: #909399;
            border-bottom: 1px solid $--border-color-base;
            border-top: 1px solid $--border-color-base;
        }

        .box {
            display: flex;
            border-bottom: 1px solid $--border-color-base;
        }

        .cell {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            height: 48px;
            padding-left: 10px;
            display: flex;
            align-items: center;

            &:nth-child(1) {
                width: 150px;
            }

            &:nth-child(2) {
                width: 100px;
            }

            &:nth-child(3) {
                flex: 1;
            }

            &:nth-child(4) {
                width: 100px;
            }

            &:nth-child(5) {
                width: 150px;
            }

            &:nth-child(6) {
                width: 150px;
            }

            &:nth-child(7) {
                width: 100px;
            }
        }
    }

    .pay__pro {
        .pay--header {
            border-bottom: 1px solid $--border-color-light;
            margin: 0 20px 100px;
            padding-bottom: 2px;

            .title {
                display: flex;
                font-size: 16px;

                .status-bar {
                    flex: 1;
                }

                .price {
                    text-align: right;
                    width: 260px;

                    .value {
                        color: $--color-danger;
                        font-size: 24px;
                    }
                }
            }

            .desc {
                display: flex;
                align-items: center;
                margin-top: 10px;

                .tips {
                    flex: 1;
                }
            }
        }
    }
</style>
